"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var date_helpers_1 = require("../../dates/date-helpers");
var server_1 = require("react-dom/server");
var styled_components_1 = __importDefault(require("styled-components"));
var first_of_date_1 = __importDefault(require("./first-of-date"));
var Label = styled_components_1.default.p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-transform: uppercase;\n  position: relative;\n  margin-bottom: 8px;\n"], ["\n  text-transform: uppercase;\n  position: relative;\n  margin-bottom: 8px;\n"])));
Label.displayName = 'Label';
var ExtendedDate = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  top: 10px;\n  left: 0;\n  text-transform: uppercase;\n"], ["\n  position: absolute;\n  top: 10px;\n  left: 0;\n  text-transform: uppercase;\n"])));
ExtendedDate.displayName = 'ExtendedDate';
function XAxisLabel(xAxisLabelFormat, translation) {
    return function () {
        var _a;
        var currentDate = new Date(this.value);
        var _b = date_helpers_1.dateMembers(currentDate), date = _b[0], month = _b[1], year = _b[2], time = _b[3], monthNumber = _b[4];
        var _isFirstOfDate = first_of_date_1.default(this.value, ((_a = this.chart.xAxis[0]) === null || _a === void 0 ? void 0 : _a.tickPositions) || []);
        var isFirst = (date === 1 || this.isFirst) && _isFirstOfDate;
        return server_1.renderToStaticMarkup(react_1.default.createElement(Label, null,
            xAxisLabelFormat === 'default' && (react_1.default.createElement(react_1.default.Fragment, null,
                (_isFirstOfDate && date) || time,
                isFirst && (react_1.default.createElement(ExtendedDate, null,
                    react_1.default.createElement("br", null),
                    " ",
                    month,
                    " ",
                    year)))),
            xAxisLabelFormat === 'day-hour' && (react_1.default.createElement(ExtendedDate, null,
                time,
                react_1.default.createElement("br", null),
                _isFirstOfDate && (react_1.default.createElement(react_1.default.Fragment, null,
                    date,
                    "/",
                    monthNumber)))),
            xAxisLabelFormat === 'month-year' && (react_1.default.createElement(ExtendedDate, null,
                month,
                " ",
                year)),
            xAxisLabelFormat === 'year-only' && react_1.default.createElement(ExtendedDate, null, year),
            xAxisLabelFormat === 'minute' && react_1.default.createElement(ExtendedDate, null, time),
            xAxisLabelFormat === 'one-year-range' && (react_1.default.createElement(react_1.default.Fragment, null,
                this.isFirst && react_1.default.createElement(ExtendedDate, null, translation('CHART:ONE_YEAR_BACK')),
                this.isLast && react_1.default.createElement(ExtendedDate, null, translation('CHART:NOW')),
                !this.isFirst && !this.isLast && react_1.default.createElement(ExtendedDate, null, null))),
            xAxisLabelFormat === '24-hour-range' && (react_1.default.createElement(react_1.default.Fragment, null,
                this.isLast && react_1.default.createElement(ExtendedDate, null, translation('CHART:NOW')),
                !this.isLast && react_1.default.createElement(ExtendedDate, null,
                    "-",
                    date_helpers_1.getDifferenceInHours(new Date(), new Date(this.value)))))));
    };
}
XAxisLabel.displayName = 'XAxisLabel';
exports.default = XAxisLabel;
var templateObject_1, templateObject_2;
